import { __decorate, __metadata } from "tslib";
import { provideTransient } from '@/inversify.config';
import _ from 'lodash';
const { reject, find, includes } = _;
function sameSpaceFunc(space) {
    return (spaceItem) => {
        return spaceItem.space_id === space.space_id;
    };
}
export const WorkspaceBatchOperationServiceSymbol = Symbol.for('WorkspaceBatchOperationService');
let WorkspaceBatchOperationService = class WorkspaceBatchOperationService {
    constructor() {
        this.selected = [];
    }
    toggleSelect(space) {
        if (this.isSelected(space)) {
            this.selected = reject(this.selected, sameSpaceFunc(space));
        }
        else {
            this.selected = [...this.selected, space];
        }
    }
    isSelected(space) {
        return !!find(this.selected, sameSpaceFunc(space));
    }
    unselectAll() {
        this.selected = [];
    }
    unselectMany(spaceIds) {
        this.selected = reject(this.selected, space => {
            return includes(spaceIds, space.space_id);
        });
    }
};
WorkspaceBatchOperationService = __decorate([
    provideTransient(WorkspaceBatchOperationServiceSymbol),
    __metadata("design:paramtypes", [])
], WorkspaceBatchOperationService);
export { WorkspaceBatchOperationService };
